export { initialFrame } from './common';
const PARAMS_MAP = {
  top: {
    dx: 0,
    dy: -1,
    distance: 120
  },
  right: {
    dx: 1,
    dy: 0,
    distance: 120
  },
  bottom: {
    dx: 0,
    dy: 1,
    distance: 120
  },
  left: {
    dx: -1,
    dy: 0,
    distance: 120
  }
};
export function web(options) {
  const {
    custom,
    ...floatIn
  } = style(options)[0];
  return [{
    ...floatIn,
    keyframes: [{
      opacity: 0,
      translate: `${custom['--motion-translate-x']} ${custom['--motion-translate-y']}`
    }, {
      opacity: 'var(--comp-opacity, 1)',
      translate: `0px 0px`
    }]
  }];
}
export function style(options) {
  const {
    direction = 'left'
  } = options.namedEffect;
  const fromParams = PARAMS_MAP[direction];
  const translateX = fromParams.dx * fromParams.distance;
  const translateY = fromParams.dy * fromParams.distance;
  return [{
    ...options,
    name: 'floatIn',
    easing: 'sineInOut',
    custom: {
      '--motion-translate-x': `${translateX}px`,
      '--motion-translate-y': `${translateY}px`
    }
  }];
}
//# sourceMappingURL=FloatIn.js.map